import { render, staticRenderFns } from "./ProductionView.vue?vue&type=template&id=425f505e&scoped=true"
import script from "./ProductionView.vue?vue&type=script&lang=js"
export * from "./ProductionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f505e",
  null
  
)

export default component.exports